import { schemeInfoApi, schemeSectionInfoApi, schemeSetDeviceChangeApi } from '@/api';
import { isEmpty, uniqBy } from 'lodash';

const state = {
  schemeInfo: null, //方案详情
  prodList: [], //设备清单列表
  containerCost: false, //是否包含成本价
  deviceTotal: 0, //设备总数
  defaultRegionId: null, //默认楼层id
  newAddDevicesPid: [],
  reginArr: [], //楼层
  gatewayDevices: [], //所有网关产品
  noPositionDevRegion: [],
  showReportType: 0, // 报告类型：0 全部，1 仅室内，2 仅室外
  estImage: {
    estSite: [],
    estHeatMap: []
  }, //网桥图片
  detailLoading: false,
  wireRedundancy: 0 // 冗余线缆
};

const mutations = {
  SET_DETAIL_LOADING(state, payload) {
    state.detailLoading = payload;
  },
  SET_SCHEME_INFO(state, payload) {
    state.schemeInfo = payload;
  },
  SET_PRODUCT_LIST(state, payload) {
    state.prodList = payload;
  },
  SET_PRODUCT_TOTAL(state, payload) {
    state.deviceTotal = payload;
  },
  SET_WIRE_REDUNDANCY(state, payload) {
    state.wireRedundancy = payload;
  },
  SET_PRODUCT_COST_FLAG(state, payload) {
    state.containerCost = payload;
  },
  SET_DEFAULT_FLOOR_ID(state, payload) {
    state.defaultRegionId = payload;
  },
  SET_NEW_ADD_DEVICE(state, payload) {
    state.newAddDevicesPid = payload;
  },
  SET_REGIN_ARR(state, payload) {
    state.reginArr = payload;
  },
  CLEAR_NEW_DEVICES(state) {
    state.newAddDevicesPid = [];
  },
  SET_GATEWAY_DEVICES(state, payload) {
    state.gatewayDevices = payload;
  },
  CLEAR_PROJECT_DETAIL_STORE(state) {
    state.schemeInfo = null;
    state.prodList = [];
    state.containerCost = true;
    state.deviceTotal = 0;
    state.defaultRegionId = null;
    state.reginArr = [];
    state.gatewayDevices = [];
  },
  SET_NO_POSITION_DEVICE_REGION(state, payload) {
    state.noPositionDevRegion = payload;
  },
  SET_SHOW_REPORT_TYPE(state, payload) {
    state.showReportType = payload;
  },
  SET_ESTIMAGE(state, data) {
    state.estImage = data;
  }
};

const actions = {
  //获取方案详情
  async getSchemeDetail({ commit }, params) {
    const {
      code,
      msg = 'error',
      data = {}
    } = await schemeInfoApi({
      query: {
        ...params
      }
    });

    if (code != 0) {
      return { success: false, msg, code };
    }

    commit('SET_SCHEME_INFO', data);
    /**
     * 只有自己的方案可以查看成本价信息
     */
    commit('SET_PRODUCT_COST_FLAG', data.includeCost === 1 && data.ownScheme);

    return { success: true, data };
  },
  //获取设备清单
  async getProductList({ commit }, params) {
    const {
      code,
      msg = 'error',
      data = {}
    } = await schemeSectionInfoApi({
      query: {
        ...params
      }
    });

    if (code != 0) {
      return { success: false, msg };
    }

    let dataList = [];
    const { sectionContent = {} } = data;

    if (params.showProdType == 0) {
      // 按设备类型显示
      const { prodList = [], totalCount = 0, wireList = [], verticalWireList = [], wireRedundancy } = sectionContent;
      commit('SET_PRODUCT_TOTAL', totalCount);
      commit('SET_WIRE_REDUNDANCY', wireRedundancy);
      prodList.forEach(item => {
        item.regionId = state.defaultRegionId;
      });

      dataList.push({
        id: state.defaultRegionId,
        regionProds: prodList,
        wireProds: wireList,
        verticalWireList: verticalWireList
      });
    } else {
      // 按楼层显示
      const { regionList = [], totalCount, wireRedundancy } = sectionContent;
      const list = [...regionList];
      list.forEach(item => {
        const { regionProds = [], id } = item;
        regionProds.forEach(it => {
          it.regionId = id;
        });
      });
      commit('SET_PRODUCT_TOTAL', totalCount);
      commit('SET_WIRE_REDUNDANCY', wireRedundancy);
      dataList = [...regionList];
    }

    commit('SET_PRODUCT_LIST', dataList);

    return { success: true, data: dataList };
  },
  //设置设备已变更（更换设备，添加/减少设备，追加设备，更换楼层）需要替换用户
  async setDeviceChange({ commit }, params) {
    const { code, msg = '设置设备已变更失败' } = await schemeSetDeviceChangeApi({
      body: {
        ...params
      }
    });
    if (code != 0) {
      return { success: false, msg };
    }
    return { success: true };
  },
  //获取默认楼层和楼层列表
  async getDefaultReginIdAndReginArr({ commit }, params) {
    const {
      code,
      msg = this.$t('projectDetail.getProListFail'),
      data = {}
    } = await schemeSectionInfoApi({
      query: {
        ...params
      }
    });

    if (code != 0) {
      return { success: false, msg };
    }

    const { sectionContent = {} } = data;
    const { regionList = [] } = sectionContent;
    let defaultFloorInfo,
      reginArr = [],
      noPositionDeviceRegin = [];

    regionList.forEach(item => {
      const {
        regionName,
        id,
        planInfo,
        hasCameraProd,
        hasWifiProd,
        regionProds = [],
        wireProds = [],
        regionType,
        regionId
      } = item;

      if (item.defaultRegion == 1) {
        defaultFloorInfo = item;
      }

      reginArr.push({
        regionId,
        regionName: regionName,
        id: id,
        regionType: regionType,
        planInfo: planInfo,
        wireProds: wireProds,
        hasCameraProd: hasCameraProd,
        hasWifiProd: hasWifiProd,
        devices: regionProds,
        hasWired: planInfo?.hasWired
      });

      regionProds.forEach(it => {
        if (!planInfo || isEmpty(planInfo)) return;
        const { isCamera, isSupportWifi, devicePosition, deviceVisible } = it;
        if (!isCamera && !isSupportWifi) return;
        if (deviceVisible == 1 && devicePosition == 0) {
          noPositionDeviceRegin.push({
            regionName,
            id
          });
        }
      });
    });

    noPositionDeviceRegin = uniqBy(noPositionDeviceRegin, 'id');
    reginArr = reginArr.filter(el => el.regionType !== 'vertical_wire');

    commit('SET_REGIN_ARR', reginArr);
    commit('SET_NO_POSITION_DEVICE_REGION', noPositionDeviceRegin);

    if (defaultFloorInfo) {
      commit('SET_DEFAULT_FLOOR_ID', defaultFloorInfo.id);
    }
  }
};

const getters = {
  //导出方案模块列表
  exportModule: state => {
    if (state.schemeInfo && state.schemeInfo.section) {
      const arr = state.schemeInfo.section.map(item => {
        return {
          ...item,
          checked: true
        };
      });
      return arr;
    } else {
      return [];
    }
  },
  //设备单价成本价列表
  devicePriceList: state => {
    const arr = [];
    state.prodList.forEach(item => {
      const { regionProds = [] } = item;
      regionProds.forEach(it => {
        const { costPrice, id, prodPrice } = it;
        arr.push({
          id,
          costPrice,
          prodPrice
        });
      });
    });

    return arr;
  },
  reginArrMap: state => {
    const obj = {};
    state.reginArr.forEach(item => {
      const { id } = item;
      obj[id] = item;
    });
    return obj;
  },
  gatewapDevicesObj: state => {
    const obj = {};
    state.gatewayDevices.forEach(item => {
      obj[item.id] = item;
    });
    return obj;
  },
  showReportType: state => {
    return state.showReportType;
  },
  estImage: state => {
    return state.estImage;
  },
  detailLoading: state => {
    return state.detailLoading;
  },
  wireRedundancy: state => {
    return state.wireRedundancy;
  }
};

export default {
  namespaced: true, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state,
  getters,
  mutations,
  actions
};
